import { AssignmentType, PhaseType } from 'models/enum';
import { CaseStudy, CaseStudyPhase, NewAssignment, SimulationEhr } from 'models/ui';
import { assetHelper } from 'helpers';
import { Avatar, Box, ChartsInvolved } from 'components/common';
import { ELSTab, ELSTabGroup } from 'components/common/els';
import OverviewTab, { OverviewTabProps } from './OverviewTab';
import Phases from './Phases';
import { Tabs } from './QuickView';
import { instructorSelectors } from 'redux/ducks/instructor';
import { connect } from 'react-redux';

export interface AssignmentInfoViewProps {
  activeTab: number;
  selectedContent: CaseStudy | SimulationEhr;
  onTabGroupClick: Function;
  isBookOrganized: boolean;
  newAssignment?: NewAssignment;
  assignmentType?: AssignmentType;
}

const AssignmentInfoView = (props: AssignmentInfoViewProps) => {
  const { id, patient, diagnosis, sherpathModule, totalTimeLimit, concept, learningObjective, phases } = props.selectedContent || {};
  const isSimulationAssignment = props.newAssignment?.assignmentType ? props.newAssignment?.assignmentType === AssignmentType.SIMULATION : props.assignmentType === AssignmentType.SIMULATION;
  if (!id) {
    return null;
  }
  const filteredPhases = phases?.length ? (phases as CaseStudyPhase[]).filter((phase) => phase.type !== PhaseType.OVERVIEW) : [];
  const overviewViewProps: OverviewTabProps = {
    diagnosis,
    chapter: sherpathModule,
    totalTimeLimit,
    concept,
    learningObjective,
    totalPhases: filteredPhases.length,
    isBookOrganized: props.isBookOrganized,
    assignmentType: props.newAssignment?.assignmentType
  };
  const chartsInvolved = [];

  filteredPhases.forEach((phase) => {
    if (phase.chartsInvolved?.length) {
      phase.chartsInvolved.forEach((chart) => !chartsInvolved.includes(chart) && chartsInvolved.push(chart));
    }
  });

  const avatarUrl = assetHelper.getStaticPatientAvatar(patient.avatarUrl);

  return (
    <>
      <Box mt2 className="quick-view__tab-group">
        <ELSTabGroup autoFocusTab activeIndex={props.activeTab} onChangeActiveIndex={props.onTabGroupClick}>
          <ELSTab id="quick-view-tab" title="Overview">
            <OverviewTab {...overviewViewProps} />
          </ELSTab>
          {!isSimulationAssignment && (
            <ELSTab id="quick-view-tab" title="Charts involved">
              <ChartsInvolved charts={chartsInvolved} />
            </ELSTab>
          )}
          <ELSTab id="quick-view-tab" title="Phases">
            <Phases phases={filteredPhases} />
          </ELSTab>
        </ELSTabGroup>
        {patient.avatarUrl && <Avatar name="AA" image={avatarUrl} className="quick-view__avatar" />}
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  newAssignment: instructorSelectors.getNewAssignment(state)
});

AssignmentInfoView.displayName = 'TabsView';
export { AssignmentInfoView as BaseAssignmentInfoView };
export default connect(mapStateToProps)(AssignmentInfoView);
